import api from './api'

export async function saveAdvisorLead(payload) {
  const { data } = await api.post('/advisor/lead', payload)
  return data
}

export async function fetchAdvisorApplicationContext(conversationId) {
  if (!conversationId || !/^[0-9a-f-]{36}$/i.test(String(conversationId))) {
    return { ok: true, lead: null }
  }
  const { data } = await api.get(`/advisor/context/${conversationId}`)
  return data
}

export function appendConversationToRegisterHref(href, conversationId, courseCode) {
  if (!href || !String(href).startsWith('/register')) return href
  const [path, query = ''] = String(href).split('?')
  const params = new URLSearchParams(query)
  if (courseCode && !params.get('course')) params.set('course', courseCode)
  if (conversationId) params.set('cid', conversationId)
  const next = params.toString()
  return next ? `${path}?${next}` : path
}
